import { render, staticRenderFns } from "./SnagsExtend.vue?vue&type=template&id=12d6d490&"
import script from "./SnagsExtend.vue?vue&type=script&lang=js&"
export * from "./SnagsExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports